import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import { clearMessages } from 'redux-flash';
import { Icon } from './Icon';
import FlashMessages from '../UI/FlashMessages';
import { classNamesPrefixed } from '../../../helpers/CoreHelpers';
import { connect } from "react-redux";
import Btn from "./Btn";
import { MediaContext } from '../../../contexts/MediaContext';

class Modal extends Component {
    static contextType = MediaContext;

    static propTypes = {
        showModal: PropTypes.bool,
        title: PropTypes.string,
        icon: PropTypes.string,
        modalHeader: PropTypes.object,
        modalFooter: PropTypes.object,
        onClose: PropTypes.func
    };

    static defaultProps = {
        title: "",
        icon: "window-maximize",
        modalHeader: null,
        modalFooter: null,
        onClose: null,
        showModal: false,
        outsideClickClose: false,
    };

    constructor(props) {
        super(props);

        const { showModal } = props;

        this.state = {
            showModal: showModal,
            top: 20
        };

        this.bodyClass(showModal);

        this.wrapperRef = null;
        this.headerRef = null;
        this.footerRef = null;
        this.beforeContentRef = null;
        this.contentRef = null;
        this.scrollbarRef = null;
        this.onScrollBarUpdate = this.onScrollBarUpdate.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this)
        this.scrollToTop = this.scrollToTop.bind(this);

    }

    componentWillReceiveProps(newProps) {
        this.setState({
            showModal: newProps.showModal
        });

        this.bodyClass(newProps.showModal);
    }

    componentDidMount() {
        document.addEventListener('keydown', this.escape.bind(this), false);

        if (this.props.outsideClickClose) {
            document.addEventListener('mousedown', this.handleClickOutside);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.escape.bind(this), false);

        if (this.props.outsideClickClose) {
            document.removeEventListener('mousedown', this.handleClickOutside);
        }
    }

    handleClickOutside(event) {
        if (this.wrapperRef && (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target))) {
            this.close()
        }
    }

    escape(event) {
        if (event.keyCode === 27) {
            this.close();
        }
    }

    close(event) {
        if (this.props.onClose) {
            this.props.onClose(event);
        }

        this.setState({
            showModal: false
        });

        this.bodyClass(false);

        this.props.clearMessages();
    }

    renderThumb = ({ style, ...props }) => {
        const thumbStyle = {};

        return (
            <div className={classNamesPrefixed({ 'custom-scroll-thumb': true })}
                style={{ ...thumbStyle }}
                {...props}>
                <Icon name={"bars"} />
            </div>
        );
    };

    bodyClass(add) {
        if (add) {
            document.body.classList.add('modal-is-open');
        } else {
            document.body.classList.remove('modal-is-open');
        }
    }

    onScrollBarUpdate(values) {
        let winHeight = window.innerHeight;
        let top = (winHeight - values.clientHeight) / 2;

        if (this.wrapperRef) {
            top = (winHeight - this.wrapperRef.clientHeight) / 2;
        }

        if (top < 0) {
            top = 0;
        }

        if (top && this.state.top !== Math.round(top)) {
            if (this.state.top !== Math.round(top)) {
                this.setState({
                    top: Math.round(top)
                });
            }
        }
    }

    scrollToTop() {
        if (this.scrollbarRef) {
            console.log(this.scrollToTopRef);
            this.scrollbarRef.scrollTop();
        }
    }

    getContentWithScroll() {
        let windowH = window.innerHeight;
        let headerH = 0;
        let footerH = 0;
        let beforeContentH = 0;
        if (this.headerRef) {
            headerH = this.headerRef.clientHeight;
        }
        if (this.footerRef) {
            footerH = this.footerRef.clientHeight;
        }
        if (this.beforeContentRef) {
            beforeContentH = this.beforeContentRef.clientHeight;
        }
        const maxContentHeight = windowH - (headerH + footerH + beforeContentH + 80);

        // console.table({
        //     windowH: windowH,
        //     headerH: headerH,
        //     footerH: footerH,
        //     beforeContentH: beforeContentH,
        //     maxContentHeight: maxContentHeight,
        // });

        return (
            <Scrollbars
                ref={(ref) => this.scrollbarRef = ref}
                renderThumbVertical={this.renderThumb}
                autoHeight={true}
                autoHeightMax={maxContentHeight}
                autoHeightMin={0}
                onUpdate={this.onScrollBarUpdate.bind(this)}
            >
                {this.getContent()}
            </Scrollbars>
        )
    }

    getContent() {
        const { children } = this.props;

        return (
            <div className={classNamesPrefixed({ 'modal-inner': true })}>
                {children}
            </div>
        )
    }

    render() {
        const { title, description, icon, modalFooter, modalHeader, className, showFlashMessages, noScroll } = this.props;
        const { showModal } = this.state;
        const { isMobile } = this.context;

        let content = null;
        let top = this.state.top;

        if (noScroll) {
            top = null;
            content = this.getContent();
        } else {
            content = this.getContentWithScroll()
        }

        if (showModal) {
            return (
                <Fragment>
                    <div
                        className={classNamesPrefixed({
                            'modal-window-wrap': true,
                            [className]: true,
                            'modal-window-wrap-flex': !top ? true : false
                        })}
                    >
                        <div ref={(ref) => this.wrapperRef = ref}
                            style={top && !isMobile ? { top: top } : {}}
                            className={classNamesPrefixed({ 'modal-window': true })}>

                            <div ref={(ref) => this.headerRef = ref}
                                className={classNamesPrefixed({ 'modal-header': true })}>
                                <div
                                    className={classNamesPrefixed({ 'modal-info': true })}>
                                    <Icon name={icon} />
                                    {title && title.length > 0 &&
                                        <span className={"title"}>{title}</span>
                                    }
                                    {description && description.length > 0 &&
                                        <p>{description}</p>
                                    }
                                </div>
                                <div
                                    className={classNamesPrefixed({ 'modal-close': true })}>
                                    <Btn onClick={(event) => this.close(event)}
                                        icon="times" />
                                </div>

                                {showFlashMessages &&
                                    <FlashMessages />
                                }
                            </div>

                            {modalHeader &&
                                <div ref={(ref) => this.beforeContentRef = ref}
                                    className={classNamesPrefixed({ 'modal-before-content': true })}>
                                    {modalHeader}
                                </div>
                            }
                            <div ref={(ref) => this.contentRef = ref}
                                className={classNamesPrefixed({ 'modal-content': true })}>
                                {content}
                            </div>
                            {modalFooter &&
                                <div ref={(ref) => this.footerRef = ref}
                                    className={classNamesPrefixed({ 'modal-footer': true })}>
                                    {modalFooter}
                                </div>
                            }
                        </div>
                    </div>
                    <div
                        className={classNamesPrefixed({ 'modal-background': true })} />
                </Fragment>
            );
        } else {
            return null;
        }
    };
}

const mapDispatchToProps = dispatch => ({
    clearMessages: () => dispatch(clearMessages())
});

export default connect(null, mapDispatchToProps)(Modal);



// WEBPACK FOOTER //
// ./src/core/admin/components/UI/Modal.js